import { render } from "./ContentTinyTable.vue?vue&type=template&id=4d880ce0"
import script from "./ContentTinyTable.vue?vue&type=script&lang=js"
export * from "./ContentTinyTable.vue?vue&type=script&lang=js"

import "./ContentTinyTable.vue?vue&type=style&index=0&id=4d880ce0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__